export const pergolaData = {
  title: 'Pergolas',
  description: 'Notre gamme de pergolas sont conçues pour vous protéger du vent, de la pluie et du soleil. Elles vous permettront de créer un espace de vie alliant raffinement et qualité tout en s\'adaptant avec votre décoration extérieur, qu\'elle soit moderne ou traditionnelle.',
  link: [
          {
              src: "https://static.wixstatic.com/media/e49d9d_a7d5513f424240edab264e20b617aab3~mv2.png",
              title: "Pergola bioclimatique",
              url: "/pergola/bioclimatique",
          },
          {
              src: "https://static.wixstatic.com/media/e49d9d_0e852e84e4c6464e9637867ca1572761~mv2.png",
              title: "Pergola toile",
              url: "/pergola/toile",
          },
        ],
}